import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductionOrderStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('ProductionOrderStatusReference');
  }
}
